import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import StarRatings from "src/components/atoms/StarRatings";
import {
  ITestimonial,
  ITestimonialFields,
  ITestimonialsSliderFields,
} from "src/types/generated/contentful";
import { down } from "styled-breakpoints";
import styled from "styled-components";
const StyledWrapper = styled.div`
  width: 100%;
  padding: 0 20%;
  margin-bottom: 20%;
  ${down("md")} {
    padding: 0;
  }
  button {
    display: none !important;
  }
`;

const StyledSlide = styled.div`
  text-align: center;
  font-style: italic;
`;

const Quote = styled.div``;

const Extra = styled.span`
  font-size: ${(props) => props.theme.typography.sm.fontSize}rem;
  font-weight: ${(props) => props.theme.typography.sm.fontWeight};
  font-family: ${(props) => props.theme.typography.sm.fontFamily};
  color: white;
`;

const Extra2 = styled(Extra)`
  color: #d4ebf4;
`;

export default function TestimonialsSlider(
  data: ITestimonialsSliderFields
): React.ReactElement {
  //console.log("TestimonialsSlider", data);

  var settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,

    centerPadding: "50px",
  };

  const { content } = data;
  return (
    <StyledWrapper>
      <Slider {...settings}>
        {content && content.length > 0 ? (
          content.map((testimonial: ITestimonial, index: number) => {
            const testf = testimonial?.fields as ITestimonialFields;
            return (
              <StyledSlide key={index}>
                <Quote>
                  {documentToReactComponents(testf?.description as any)}
                </Quote>
                <StarRatings />

                <div>
                  <Extra>{testf?.author}</Extra>{" "}
                  <Extra2>
                    {testf?.reviewDateAndTime} {testf?.authorsCityStateCode}
                  </Extra2>
                </div>
              </StyledSlide>
            );
          })
        ) : (
          <div>No testimonials found</div>
        )}
      </Slider>
    </StyledWrapper>
  );
}
